import { request } from "@/interface/helper";

const str = "home";

export const home = {
  [`${str}`]: {
    homecount: (data) => request({ data, method: "get", url: "/report/home" }),
    language: (data) => request({ data, method: "get", url: "/home/language" }),
  },
};
